export default __webpack_public_path__ + "static/busy_machines_logo-8ddb4fd1d8a4bc8f551022e9f063ee3d.svg";